import { createContext } from 'react';

export const ParentPropsOverrideContext = createContext({});
